import { uniqueId } from "lodash";
import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { getMembersByName } from "../../../services/formCombos.service.js";
import { getInputDateFormats } from "../../../utils/get-date-time-locale";
import Textarea from "../../Common/Textarea";
import Toastmessage from "../../Common/ToastMessage";

import {
  Button,
  Checkbox,
  Chip,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  Grid,
  makeStyles,
  Paper,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from "@material-ui/core";
import { Face, Send } from "@material-ui/icons";
import { KeyboardDatePicker } from "@material-ui/pickers";
import moment from "moment";
import { MdGroups } from "react-icons/md";
import InputMask from "react-input-mask";
import { useAuth } from "../../../context/auth";
import { useCommittees } from "../../../hooks/useCommittees";
import { useFormCombos } from "../../../hooks/useFormCombos";
import { actionShowSpinner } from "../../../redux-flow/action/Wrapper/Spinner";
import { addMeeting } from "../../../services/meeting.service";
import { getMembersByCommitteeId } from "../../../services/members.service.js";
import { Select } from "../../Common/Select";
import { checkAccess } from "../utils/index";
import { WrapperChip } from "./styles.js";

const DAYSOFWEEKDEFAULT = [
  { id: 1, name: "monday" },
  { id: 2, name: "tuesday" },
  { id: 3, name: "wednesday" },
  { id: 4, name: "thursday" },
  { id: 5, name: "friday" },
  { id: 6, name: "saturday" },
  { id: 0, name: "sunday" },
];

const useStyles = makeStyles((theme) => ({
  root: {
    padding: "1vh 1vw",
  },
  paper: {
    padding: 40,
    marginBottom: 40,
  },
  title: {
    ...theme.typography.subtitle2,
    marginBottom: 20,
  },
  cancelIcon: {
    color: theme.palette.error.main,
  },
  iconText: {
    ...theme.typography.subtitle1,
    cursor: "pointer",
  },
  button: {
    ...theme.typography.subtitle1,
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    textTransform: "capitalize",
    minWidth: 180,
    minHeight: 50,
  },
  buttonOutlined: {
    ...theme.typography.subtitle1,
    border: "2px solid",
    color: theme.palette.grey.main,
    textTransform: "capitalize",
    minWidth: 180,
    minHeight: 50,
  },
  spacer: {
    marginBottom: 20,
  },
}));

const FormMetting = ({ t, i18n, history, actionShowSpinner }) => {
  const classes = useStyles();
  const { userAccess } = useAuth();

  const [value, setValue] = useState({
    frequencyMonth: "frequencyDayOfMonths",
    frequencyYear: "periodMonths",
    recurrence: false,
    roundRobin: false,
    onlineMeet: true,
  });
  const [memberName, setMemberName] = useState([]);
  const [message, setMessage] = useState({
    open: false,
    content: "",
    type: "",
    autoHideDuration: 4000,
  });

  const [selectedAttendees, setSelectedAttendees] = useState([]);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [selectedStartDate, setSelectedStartDate] = useState(new Date());
  const [selectedEndDate, setSelectedEndDate] = useState(new Date());
  const [secretary, setSecretary] = useState();

  const [meetingPartcipantsOptions, setMeetingPartcipantsOptions] = useState(
    []
  );
  const [secretaryOptions, setSecretaryOptions] = useState([]);

  const [programEndDay, setProgramEndDay] = useState(false);
  const [selectedDaysWeeklyFrequency, setSelectedDaysWeeklyFrequency] =
    useState([]);

  const [canCreateMeet, setCanCreateMeet] = useState(false);

  const {
    getFrequencyMeeting,
    frequencyMeeting,
    days,
    getDaysFormMeetForm,
    getEndAfter,
    endAfter,
    ordinalNumber,
    getOrdinalNumber,
    getMonths,
    months,
  } = useFormCombos();

  const { getActiveCommitteesByLanguageId, committeesListSelect } =
    useCommittees({
      spinner: actionShowSpinner,
    });

  useEffect(() => {
    if (userAccess) {
      const hasAccess = checkAccess(userAccess, "createMeet");
      const hasAccessToShowMeet = checkAccess(userAccess, "lookupMeet");

      setCanCreateMeet(hasAccess);
      if (!hasAccess && !hasAccessToShowMeet) {
        history.push("/");
      }

      if (i18n.language) {
        getMonths(i18n.language);
        getActiveCommitteesByLanguageId(i18n.language);
        getFrequencyMeeting(i18n.language);
        getDaysFormMeetForm(i18n.language);
        getEndAfter(i18n.language);
        getOrdinalNumber(i18n.language);
      }
    }
  }, [i18n.language, userAccess]);

  useEffect(() => {
    if (value?.participant?.id) {
      if (
        selectedAttendees
          .map((participant) => participant.id)
          .includes(value.participant.id)
      ) {
        return;
      }

      setSelectedAttendees([...selectedAttendees, value.participant]);
      setValue({ ...value, participant: {} });
    }
  }, [value.participant]);

  useEffect(() => {
    if (memberName?.length >= 3) {
      const delayDebounceFn = setTimeout(() => {
        getMembersByName("pt", memberName).then((res) => {
          if (res.error?.length > 0) {
            setMeetingPartcipantsOptions([]);
          }

          const list = res.data.filter(
            (participant) =>
              !selectedAttendees
                .map((participant) => participant.id)
                .includes(participant.id)
          );

          setMeetingPartcipantsOptions(list);
        });
      }, 1000);

      return () => clearTimeout(delayDebounceFn);
    } else {
      setMeetingPartcipantsOptions([]);
    }
  }, [memberName]);

  useEffect(() => {
    if (secretary?.length >= 3) {
      const delayDebounceFn = setTimeout(() => {
        getMembersByName("pt", secretary).then((res) => {
          if (res.error?.length > 0) {
            setSecretaryOptions([]);
          }

          setSecretaryOptions(res.data);
        });
      }, 1000);

      return () => clearTimeout(delayDebounceFn);
    } else {
      setSecretaryOptions([]);
    }
  }, [secretary]);

  const handleChange = (event) => {
    setValue({ ...value, [event.target.name]: event.target.value });
  };

  const handleChangeCheckbox = (event) => {
    setValue({
      ...value,
      [event.target.name]: event.target.checked,
      interval: event.target.checked ? "" : value.interval,
    });
  };

  const manageCommitteeMembers = async (committee) => {
    const attendeesWithoutCommitteeMembers = selectedAttendees.filter(
      (member) => {
        return !member.hasOwnProperty("isCommitteeMember");
      }
    );

    if (!committee) {
      setSelectedAttendees(attendeesWithoutCommitteeMembers);
      return;
    }

    const committeeId = committee.id;
    try {
      const committeeMembers =
        (await getMembersByCommitteeId(committeeId)) || [];

      const committeeMembersFormatted = committeeMembers
        .filter(
          (member) =>
            !selectedAttendees.some(
              (selectedMember) => selectedMember.id === member.idMember
            )
        )
        .map((member) => ({
          id: member.idMember,
          name: member.memberName,
          email: member.memberEmail,
          isCommitteeMember: true,
        }));

      setSelectedAttendees([
        ...attendeesWithoutCommitteeMembers,
        ...committeeMembersFormatted,
      ]);
    } catch (error) {
      setMessage({
        open: true,
        content: t("meeting.getCommitteeMembersError"),
        type: "error",
        autoHideDuration: 4000,
      });
    }
  };

  const handleChangeSelect = (selected, name) => {
    setValue({ ...value, [name]: selected });
  };

  const validateForm = () => {
    let errors = [];

    if (!value.committee || !value.committee.id || !value.committee.name) {
      errors.push(t("meeting.committeeFieldRequired"));
    }

    if (!value.secretary || !value.secretary.id || !value.secretary.name) {
      errors.push(t("meeting.secretaryFieldRequired"));
    }

    if (!value?.startTime && !value.roundRobin) {
      errors.push(t("meeting.startTimeFieldRequired"));
    }

    if (!value?.endTime && !value.roundRobin) {
      errors.push(t("meeting.endTimeFieldRequired"));
    }

    if (value.recurrence && !value?.frequency?.name) {
      errors.push(t("meeting.frequencyFieldRequired"));
    }

    if (
      value.recurrence &&
      value?.frequency?.name === "Diário" &&
      !value.interval &&
      !value.allDays
    ) {
      errors.push(t("meeting.dayIntervalRequired"));
    }

    if (
      value.recurrence &&
      value?.frequency?.name === "Semanal" &&
      !value.intervalWeek
    ) {
      errors.push(t("meeting.weekIntervalRequired"));
    }

    if (
      value.recurrence &&
      value?.frequency?.name === "Semanal" &&
      selectedDaysWeeklyFrequency.length < 1
    ) {
      errors.push(t("meeting.weekDaySelectionError"));
    }

    if (
      value.recurrence &&
      value?.frequency?.name === "Mensal" &&
      value.frequencyMonth === "frequencyDayOfMonths" &&
      !value?.dayOfMonth
    ) {
      errors.push("meeting.dayOfMonthRequired");
    }

    if (
      value.recurrence &&
      value?.frequency?.name === "Mensal" &&
      value.frequencyMonth === "frequencyDayOfMonths" &&
      !value.intervalMonth
    ) {
      errors.push("meeting.intervalRequired");
    }

    if (
      value.recurrence &&
      value?.frequency?.name === "Mensal" &&
      value.frequencyMonth === "frequencyIntervalOfMonths" &&
      !value.ordinalNumber
    ) {
      errors.push("meeting.orderRequired");
    }

    if (
      value.recurrence &&
      value?.frequency?.name === "Mensal" &&
      value.frequencyMonth === "frequencyIntervalOfMonths" &&
      !value.frequencyIntervalDay
    ) {
      errors.push("meeting.dayOfWeekRequired");
    }

    if (
      value.recurrence &&
      value?.frequency?.name === "Mensal" &&
      value.frequencyMonth === "frequencyIntervalOfMonths" &&
      !value.qtdMonths
    ) {
      errors.push("meeting.monthQuantityRequired");
    }

    if (
      value.recurrence &&
      value?.frequency?.name === "Anual" &&
      !value.periodYearMonthSelected
    ) {
      errors.push("meeting.yearIntervalRequired");
    }

    if (
      value.recurrence &&
      value?.frequency?.name === "Anual" &&
      !value.periodYearMonthSelected
    ) {
      errors.push("meeting.monthFieldRequired");
    }

    if (
      value.recurrence &&
      value?.frequency?.name === "Anual" &&
      value.frequencyYear === "periodMonths" &&
      !value.periodMonthsCount
    ) {
      errors.push("meeting.dayQuantityRequired");
    }

    if (
      value.recurrence &&
      value?.frequency?.name === "Anual" &&
      value.frequencyYear === "periodYears" &&
      !value.periodYearsOrdinalNumber
    ) {
      errors.push("meeting.orderFieldRequired");
    }

    if (
      value.recurrence &&
      value?.frequency?.name === "Anual" &&
      value.frequencyYear === "periodYears" &&
      !value.periodYearsDay
    ) {
      errors.push("meeting.weekDayRequired");
    }

    if (value.recurrence && programEndDay && !value.endProgram) {
      errors.push("meeting.scheduleClosingRequired");
    }

    if (value.recurrence && !selectedStartDate) {
      errors.push("meeting.startDateFieldRequired");
    }

    if (value.recurrence && !selectedEndDate && !programEndDay) {
      errors.push("meeting.endDateFieldRequired");
    }

    return errors;
  };

  const handleSave = async () => {
    const errors = validateForm();
    actionShowSpinner(true);

    if (errors.length > 0) {
      setMessage({
        open: true,
        content: errors,
        type: "error",
      });

      actionShowSpinner(false);

      return;
    }

    let frequencyYear = "";

    if (value?.frequencyYear === "periodYears") {
      frequencyYear = "W";
    }
    if (value?.frequencyYear === "periodMonths") {
      frequencyYear = "Y";
    }

    let frequencyMonth = "";

    if (value.frequencyMonth === "frequencyDayOfMonths") {
      frequencyMonth = "D";
    }

    if (value.frequencyMonth === "frequencyIntervalOfMonths") {
      frequencyMonth = "W";
    }

    const request = {
      roundRobin: value.roundRobin,
      committee: {
        id: value.committee && value.committee.id,
        name: value.committee && value.committee.name,
      },
      secretary: {
        id: value.secretary && value.secretary.id,
        name: value.secretary && value.secretary.name,
      },
      scheduleMeetInput: {
        timeZoneId: "E. South America Standard Time",
        subject: value.subject,
        locationName: value.place,
        onlineMeetingProvider: value.onlineMeet,
        meetDate: moment(selectedDate).format("YYYY-MM-DD"),
        MeetStartDate: selectedStartDate,
        ...(!programEndDay && { ClousureDate: selectedEndDate }),
        meetStartTime: value.roundRobin ? "00:00" : value?.startTime,
        MeetEndTime: value.roundRobin ? "23:59" : value?.endTime,
        isRecurrence: value?.recurrence,
        observation: value?.comments,
        ...(value.recurrence && {
          kindOfFrequencyJson: {
            ...(value?.interval && {
              DailySpecificInterval: Number(value?.interval),
            }),
            ...(value?.frequency?.id &&
              value?.frequency?.id === "D" && {
                KindScheduleMeetDay:
                  value?.interval > 0 && value?.frequency?.id === "D"
                    ? "I"
                    : "A",
              }),
            ...(frequencyYear.length > 0 &&
              value?.frequency?.id === "A" && {
                kindScheduleMeetYear: frequencyYear,
              }),
            ...(frequencyMonth.length > 0 &&
              value?.frequency?.id === "M" && {
                kindScheduleMeetMonth: frequencyMonth,
              }),
            ...(value?.intervalYear && {
              yearSpecificInterval: value?.intervalYear,
            }),
            ...(value?.intervalWeek && {
              weekSpecificInterval: Number(value?.intervalWeek),
            }),
            ...(value?.periodMonthsCount &&
              value.frequency.id === "A" &&
              value.frequencyYear === "periodMonths" && {
                periodMonths: value?.periodMonthsCount,
              }),
            ...(value?.periodYearMonthSelected?.id && {
              periodYearMonth: value?.periodYearMonthSelected?.id,
            }),
            ...(value?.endProgram?.id && {
              numberOfOccurrences:
                value?.endProgram?.id !== 0
                  ? value?.endProgram?.id
                  : null,
            }),
            ...(value.frequencyMonth === "frequencyDayOfMonths" && {
              scheduleMeetMonthFromDay: {
                dayOfMonth: value?.dayOfMonth,
                monthSpecificInterval: value?.intervalMonth,
              },
            }),
            ...(value.frequencyYear !== "periodMonths" &&
              value.frequency.id === "A" && {
                scheduleMeetYearFromWeekDay: {
                  indexWeekDay:
                    value?.periodYearsOrdinalNumber.id ||
                    value.ordinalNumber.id,
                  intervalFirstDayOfWeek:
                    value?.periodYearsDay.id ||
                    value.frequencyIntervalDay.id,
                  monthSpecificInterval:
                    value.qtdMonths || value?.intervalMonth,
                },
              }),
            ...(value.frequencyMonth === "frequencyIntervalOfMonths" &&
              value.frequency.id === "M" && {
                scheduleMeetMonthFromWeekDay: {
                  indexWeekDay:
                    value?.periodYearsOrdinalNumber.id ||
                    value.ordinalNumber.id,
                  intervalFirstDayOfWeek:
                    value?.periodYearsDay.id ||
                    value.frequencyIntervalDay.id,
                  monthSpecificInterval:
                    value?.intervalMonth || value.qtdMonths,
                },
              }),
            ...(value?.intervalWeek && {
              weekSpecificInterval: Number(value?.intervalWeek),
            }),
            ...(selectedDaysWeeklyFrequency && {
              daysOfWeek: selectedDaysWeeklyFrequency,
            }),
            ...(value.periodYearsDay &&
              value.frequencyYear === "periodYears" && {
                daysOfWeek: [value.periodYearsDay.id],
              }),
          },
        }),
        frequencyId: value?.frequency && value?.frequency?.id,
        attendees: selectedAttendees,
        numberOfOccurrences:
          value?.endProgram?.id !== 0 ? value?.endProgram?.id : null,
      },
    };

    const res = await addMeeting(request);

    actionShowSpinner(false);

    if (res.error.length > 0) {
      let message = res.error;

      setMessage({
        open: true,
        content: message,
        type: "error",
      });

      return;
    }

    setSelectedDate(new Date());
    setValue({
      frequencyMonth: "frequencyDayOfMonths",
      frequencyYear: "periodMonths",
      recurrence: false,
      secretary: undefined,
      subject: undefined,
      place: undefined,
      startTime: undefined,
      endTime: undefined,
      recurrence: undefined,
      comments: undefined,
      frequency: undefined,
    });
    setSecretary();
    setSelectedAttendees([]);

    history.push({
      pathname: "/meetings",
      state: { successCreateMeet: true },
    });
  };

  const handleRemoveMember = (memberDelSelected) => {
    setSelectedAttendees((oldValue) =>
      oldValue.filter((member) => member.id !== memberDelSelected.id)
    );
  };

  return (
    <Grid container className={classes.root}>
      <Grid
        container
        item
        direction="row"
        justify="space-between"
        className={classes.spacer}
      >
        <Grid item md={6} lg={6}>
          <Typography variant="h4">{t(`meeting.new`)}</Typography>
        </Grid>
      </Grid>

      <Grid container direction="row" spacing={3}>
        <Grid item lg={8} xs={12}>
          <Paper elevation={1} className={classes.paper}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Typography
                className={classes.title}
                style={{ marginBottom: "0px" }}
              >
                {t("forms.committee.info")}
              </Typography>

              <FormControlLabel
                fullWidth
                control={
                  <Checkbox
                    value={value.roundRobin}
                    checked={value.roundRobin}
                    onChange={() =>
                      setValue((oldValue) => ({
                        ...oldValue,
                        roundRobin: !oldValue.roundRobin,
                      }))
                    }
                    name="roundRobin"
                    id="roundRobin"
                    color="primary"
                  />
                }
                label={t("meeting.roundRobin")}
              />
            </div>

            <Grid container spacing={3}>
              <Grid item lg={6} xs={12}>
                <Select
                  id="committee"
                  options={committeesListSelect}
                  value={value.committee}
                  setValue={(value) => {
                    handleChangeSelect(value, "committee");
                    manageCommitteeMembers(value);
                  }}
                  label={t("forms.committee.nameCommittee")}
                  error={value.committee ? false : true}
                  required={true}
                />
              </Grid>

              <Grid item lg={6} xs={12}>
                <Select
                  id="secretary"
                  options={secretaryOptions}
                  value={value.secretary}
                  required={true}
                  setValue={(value) => handleChangeSelect(value, "secretary")}
                  onInputChange={(_event, newInputValue, _prop) => {
                    setSecretary(newInputValue);
                  }}
                  inputValue={secretary}
                  error={!value.secretary}
                  label={t("forms.committee.secretary")}
                />
              </Grid>

              <Grid item lg={6} xs={12}>
                <TextField
                  name="subject"
                  id="subject"
                  onChange={handleChange}
                  value={value.subject || ""}
                  label={t("meeting.subject")}
                  fullWidth
                  autoComplete="nope"
                />
              </Grid>

              <Grid item lg={3} xs={6}>
                <FormControlLabel
                  fullWidth
                  control={
                    <Checkbox
                      value={value.onlineMeet}
                      checked={value.onlineMeet}
                      onChange={(event) => {
                        setValue({ ...value, onlineMeet: !value.onlineMeet });
                      }}
                      name="onlineMeet"
                      id="onlineMeet"
                      color="primary"
                    />
                  }
                  label={t("meeting.onlineMeet")}
                />
              </Grid>

              {!value.onlineMeet && (
                <Grid item lg={3} xs={12}>
                  <TextField
                    name="place"
                    id="place"
                    onChange={handleChange}
                    value={value.place || ""}
                    label={t("meeting.place")}
                    fullWidth
                    autoComplete="nope"
                  />
                </Grid>
              )}

              <Grid item lg={6} xs={12}>
                <KeyboardDatePicker
                  autoOk
                  disableToolbar
                  variant="inline"
                  format={getInputDateFormats(i18n.language)}
                  id="date-picker-inline"
                  fullWidth
                  required
                  label={t("meeting.meetingDate")}
                  value={selectedDate}
                  onChange={(date) => setSelectedDate(date)}
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                  error={selectedDate ? false : true}
                />
              </Grid>

              <Grid item lg={3} xs={6}>
                {!value.roundRobin && (
                  <InputMask
                    mask="99:99"
                    maskChar=""
                    name="startTime"
                    onChange={handleChange}
                    required
                    value={value.startTime || ""}
                  >
                    {() => (
                      <TextField
                        fullWidth
                        name="startTime"
                        onChange={handleChange}
                        value={value.startTime || ""}
                        inputProps={{
                          id: "startTime",
                        }}
                        label={t("meeting.startTime")}
                        required={true}
                        error={value.startTime ? false : true}
                      />
                    )}
                  </InputMask>
                )}
              </Grid>

              <Grid item lg={3} xs={6}>
                {!value.roundRobin && (
                  <InputMask
                    mask="99:99"
                    maskChar=""
                    name="endTime"
                    onChange={handleChange}
                    disabled={value.roundRobin}
                    required={!value.roundRobin}
                    value={value.endTime || ""}
                  >
                    {() => (
                      <TextField
                        fullWidth
                        name="endTime"
                        onChange={handleChange}
                        value={value.endTime || ""}
                        required={!value.roundRobin}
                        inputProps={{
                          id: "endTime",
                        }}
                        label={t("meeting.endTime")}
                        error={
                          value.endTime && !value.roundRobin ? false : true
                        }
                      />
                    )}
                  </InputMask>
                )}
              </Grid>

              <Grid item lg={12} xs={12}>
                <Textarea
                  name="comments"
                  id="comments"
                  onChange={handleChange}
                  value={value.comments || ""}
                  label={t("meeting.comments")}
                />
              </Grid>

              <Grid item style={{ display: "flex" }} lg={6} xs={12}>
                <TextField
                  name="status"
                  id="status"
                  value={t("meeting.meetingStatus.open")}
                  label={t("meeting.status")}
                  fullWidth
                  autoComplete="nope"
                />
              </Grid>

              <Grid item lg={12} xs={12}>
                <FormControlLabel
                  control={
                    <Checkbox
                      value={value.recurrence || false}
                      checked={value.recurrence || false}
                      onChange={handleChangeCheckbox}
                      disabled={value.roundRobin}
                      name="recurrence"
                      id="recurrence"
                      color="primary"
                    />
                  }
                  label={t("meeting.recurrence")}
                />
              </Grid>

              {value.recurrence && (
                <>
                  <Grid item lg={4} xs={12}>
                    <Select
                      id="frequency"
                      options={frequencyMeeting}
                      value={value.frequency}
                      required={true}
                      disabled={value.roundRobin}
                      error={!value.frequency}
                      setValue={(newValue) => {
                        setSelectedDaysWeeklyFrequency([]);
                        setValue({
                          ...value,
                          interval: "",
                          allDays: "",
                          intervalWeek: "",
                          intervalMonth: "",
                          ordinalNumber: "",
                          frequencyIntervalDay: "",
                          qtdMonths: "",
                          intervalYear: "",
                          frequencyYear: "periodMonths",
                          periodMonthsCount: "",
                          periodMonthSelected: "",
                          periodYearsOrdinalNumber: "",
                          periodYearsDay: "",
                          periodYearMonthSelected: "",
                          frequency: newValue,
                        });
                      }}
                      label={t("forms.committee.frequency")}
                    />
                  </Grid>

                  {value.frequency &&
                    value.frequency.id === "D" &&
                    !value.allDays && (
                      <Grid item lg={6} xs={12}>
                        <TextField
                          name="interval"
                          id="interval"
                          disabled={value.roundRobin}
                          onChange={(event) =>
                            setValue({
                              ...value,
                              [event.target.name]: event.target.value,
                              allDays: false,
                            })
                          }
                          value={value.interval || ""}
                          label={t("meeting.interval")}
                          fullWidth
                          required
                          autoComplete="nope"
                          error={!value.interval && !value.allDays}
                        />
                      </Grid>
                    )}

                  {value.frequency && value.frequency.id === "D" && (
                    <Grid item lg={4} xs={12}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            value={value.allDays || false}
                            checked={value.allDays || false}
                            onChange={handleChangeCheckbox}
                            name="allDays"
                            disabled={value.roundRobin}
                            id="allDays"
                            color="primary"
                          />
                        }
                        label={t("meeting.allDays")}
                      />
                    </Grid>
                  )}

                  {value.frequency && value.frequency.id === "S" && (
                    <Grid item lg={6} xs={12}>
                      <InputMask
                        mask="9999"
                        maskChar=""
                        disabled={value.roundRobin}
                        onChange={handleChange}
                        value={value.intervalWeek || ""}
                        error={!value.intervalWeek}
                      >
                        {() => (
                          <TextField
                            name="intervalWeek"
                            id="intervalWeek"
                            value={value.intervalWeek || ""}
                            error={!value.intervalWeek}
                            label={t("meeting.intervalWeek")}
                            onChange={handleChange}
                            fullWidth
                            required
                            autoComplete="nope"
                          />
                        )}
                      </InputMask>
                    </Grid>
                  )}

                  {value.frequency && value.frequency.id === "S" && (
                    <Grid
                      item
                      lg={12}
                      xs={12}
                      style={
                        selectedDaysWeeklyFrequency?.length < 1
                          ? { borderRadius: "8px", border: "1px solid red" }
                          : {}
                      }
                    >
                      <FormControl component="fieldset">
                        <FormLabel
                          required={true}
                          component="legend"
                          style={
                            selectedDaysWeeklyFrequency?.length < 1
                              ? {
                                  marginBottom: 20,
                                  color: "red",
                                }
                              : {
                                  marginBottom: 20,
                                }
                          }
                          disabled={value.roundRobin}
                        >
                          {t("forms.committee.daysOfWeek.title")}
                        </FormLabel>

                        <FormGroup>
                          {DAYSOFWEEKDEFAULT.map((item) => (
                            <FormControlLabel
                              key={uniqueId()}
                              control={
                                <Checkbox
                                  color="primary"
                                  disabled={value.roundRobin}
                                  checked={selectedDaysWeeklyFrequency.includes(
                                    item.id
                                  )}
                                  onChange={(_event) => {
                                    if (
                                      selectedDaysWeeklyFrequency.includes(
                                        item.id
                                      )
                                    ) {
                                      const selectedDaysWithoutThis =
                                        selectedDaysWeeklyFrequency.filter(
                                          (day) => day !== item.id
                                        );

                                      setSelectedDaysWeeklyFrequency(
                                        selectedDaysWithoutThis
                                      );
                                    } else {
                                      setSelectedDaysWeeklyFrequency([
                                        ...selectedDaysWeeklyFrequency,
                                        item.id,
                                      ]);
                                    }
                                  }}
                                  name={item.name}
                                />
                              }
                              label={t(
                                `forms.committee.daysOfWeek.${item.name}`
                              )}
                            />
                          ))}
                        </FormGroup>

                        <span style={{ color: "red", fontSize: "16px" }}>
                          {selectedDaysWeeklyFrequency?.length < 1
                            ? "SELECIONE AO MENOS UM DIA DA SEMANA"
                            : ""}
                        </span>
                      </FormControl>
                    </Grid>
                  )}

                  {value.frequency && value.frequency.id === "M" && (
                    <Grid item lg={12} xs={12}>
                      <FormControl component="fieldset">
                        <RadioGroup
                          disabled={value.roundRobin}
                          aria-label="frequencyMonth"
                          name="frequencyMonth"
                          value={value.frequencyMonth}
                          onChange={handleChange}
                          required={true}
                          row
                        >
                          <FormControlLabel
                            value="frequencyDayOfMonths"
                            disabled={value.roundRobin}
                            control={<Radio size="small" />}
                            label={t("meeting.frequencyDayOfMonths")}
                          />
                          <FormControlLabel
                            disabled={value.roundRobin}
                            value="frequencyIntervalOfMonths"
                            control={<Radio size="small" />}
                            label={t("meeting.frequencyIntervalOfMonths")}
                          />
                        </RadioGroup>
                      </FormControl>
                    </Grid>
                  )}

                  {value.frequencyMonth &&
                    value.frequencyMonth === "frequencyDayOfMonths" &&
                    value.frequency &&
                    value.frequency.id === "M" && (
                      <>
                        <Grid item lg={4} xs={12}>
                          <TextField
                            name="dayOfMonth"
                            id="dayOfMonth"
                            error={!value?.dayOfMonth}
                            value={value?.dayOfMonth || ""}
                            disabled={value.roundRobin}
                            label={t("meeting.dayOfMonth")}
                            onChange={handleChange}
                            fullWidth
                            required
                            autoComplete="nope"
                          />
                        </Grid>

                        <Grid item lg={6} xs={12}>
                          <TextField
                            name="intervalMonth"
                            id="intervalMonth"
                            error={!value.intervalMonth}
                            disabled={value.roundRobin}
                            value={value.intervalMonth || ""}
                            label={t("meeting.intervalMonth")}
                            onChange={handleChange}
                            fullWidth
                            required
                            autoComplete="nope"
                          />
                        </Grid>
                      </>
                    )}

                  {value.frequencyMonth &&
                    value.frequencyMonth === "frequencyIntervalOfMonths" &&
                    value.frequency &&
                    value.frequency.id === "M" && (
                      <>
                        <Grid item lg={4} xs={12}>
                          <Select
                            id="ordinalNumber"
                            options={ordinalNumber}
                            required
                            disabled={value.roundRobin}
                            error={
                              !value.ordinalNumber && value.frequency.id === "M"
                            }
                            value={value.ordinalNumber}
                            setValue={(value) =>
                              handleChangeSelect(value, "ordinalNumber")
                            }
                            label={t("meeting.ordinalNumber")}
                          />
                        </Grid>

                        <Grid item lg={4} xs={12}>
                          <Select
                            id="frequencyIntervalDay"
                            options={days}
                            required
                            error={!value.frequencyIntervalDay}
                            disabled={value.roundRobin}
                            value={value.frequencyIntervalDay}
                            setValue={(value) =>
                              handleChangeSelect(value, "frequencyIntervalDay")
                            }
                            label={t("forms.committee.daysOfWeek.title")}
                          />
                        </Grid>

                        <Grid item lg={4} xs={12}>
                          <TextField
                            name="qtdMonths"
                            id="qtdMonths"
                            error={!value.qtdMonths}
                            disabled={value.roundRobin}
                            value={value.qtdMonths || ""}
                            label={t("meeting.qtdMonths")}
                            onChange={handleChange}
                            fullWidth
                            required
                            autoComplete="nope"
                          />
                        </Grid>
                      </>
                    )}

                  {value.frequency && value.frequency.id === "A" && (
                    <Grid item lg={6} xs={12}>
                      <TextField
                        name="intervalYear"
                        id="intervalYear"
                        value={value.intervalYear || ""}
                        disabled={value.roundRobin}
                        label={t("meeting.intervalYear")}
                        onChange={handleChange}
                        fullWidth
                        error={
                          value.frequency.id === "A" && !value.intervalYear
                        }
                        required
                        autoComplete="nope"
                      />
                    </Grid>
                  )}

                  {value.frequency && value.frequency.id === "A" && (
                    <>
                      <Grid item lg={4} xs={12}>
                        <FormControl component="fieldset">
                          <RadioGroup
                            aria-label="frequencyYear"
                            name="frequencyYear"
                            value={value.frequencyYear}
                            onChange={handleChange}
                            disabled={value.roundRobin}
                            required={true}
                            row
                          >
                            <FormControlLabel
                              value="periodMonths"
                              control={<Radio size="small" />}
                              label={t("meeting.periodMonths")}
                            />
                            <FormControlLabel
                              value="periodYears"
                              control={<Radio size="small" />}
                              label={t("meeting.periodYears")}
                            />
                          </RadioGroup>
                        </FormControl>
                      </Grid>

                      <Grid item lg={6}>
                        <Select
                          id="periodYearMonthSelected"
                          options={months}
                          disabled={value.roundRobin}
                          value={value.periodYearMonthSelected}
                          required
                          error={
                            !value.periodYearMonthSelected &&
                            value.frequency.id === "A"
                          }
                          setValue={(value) =>
                            handleChangeSelect(value, "periodYearMonthSelected")
                          }
                          label={t("forms.committee.month")}
                        />
                      </Grid>
                    </>
                  )}

                  {value.frequency &&
                    value.frequency.id === "A" &&
                    value.frequencyYear &&
                    value.frequencyYear === "periodMonths" && (
                      <>
                        <Grid item lg={4} xs={12}>
                          <TextField
                            name="periodMonthsCount"
                            disabled={value.roundRobin}
                            id="periodMonthsCount"
                            value={value.periodMonthsCount || ""}
                            label={t("meeting.periodMonthsCount")}
                            error={!value.periodMonthsCount}
                            onChange={handleChange}
                            fullWidth
                            required
                            autoComplete="nope"
                          />
                        </Grid>
                      </>
                    )}

                  {value.frequency &&
                    value.frequency.id === "A" &&
                    value.frequencyYear &&
                    value.frequencyYear === "periodYears" && (
                      <>
                        <Grid item lg={4} xs={12}>
                          <Select
                            id="periodYearsOrdinalNumber"
                            disabled={value.roundRobin}
                            options={ordinalNumber}
                            required
                            value={value.periodYearsOrdinalNumber}
                            error={
                              !value.periodYearsOrdinalNumber &&
                              value.frequency.id === "A"
                            }
                            setValue={(value) =>
                              handleChangeSelect(
                                value,
                                "periodYearsOrdinalNumber"
                              )
                            }
                            label={t("meeting.ordinalNumber")}
                          />
                        </Grid>

                        <Grid item lg={6} xs={12}>
                          <Select
                            id="periodYearsDay"
                            options={days}
                            value={value.periodYearsDay}
                            required
                            error={
                              !value.periodYearsDay &&
                              value.frequency.id === "A"
                            }
                            disabled={value.roundRobin}
                            setValue={(value) =>
                              handleChangeSelect(value, "periodYearsDay")
                            }
                            label={t("forms.committee.daysOfWeek.title")}
                          />
                        </Grid>
                      </>
                    )}

                  {value.frequency && (
                    <>
                      <Grid item lg={6} xs={12}>
                        <KeyboardDatePicker
                          autoOk
                          disableToolbar
                          variant="inline"
                          format={getInputDateFormats(i18n.language)}
                          id="startDate"
                          disabled={value.roundRobin}
                          fullWidth
                          label={t("meeting.startDate")}
                          value={selectedStartDate}
                          onChange={(date) => setSelectedStartDate(date)}
                          KeyboardButtonProps={{
                            "aria-label": "change date",
                          }}
                          error={!selectedStartDate}
                          required={true}
                        />
                      </Grid>

                      <Grid item lg={4} xs={12}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              value={programEndDay}
                              checked={programEndDay}
                              onChange={() => setProgramEndDay(!programEndDay)}
                              disabled={value.roundRobin}
                              name="programEndDay"
                              id="programEndDay"
                              color="primary"
                            />
                          }
                          label={t("meeting.programEndDay")}
                        />
                      </Grid>

                      {programEndDay ? (
                        <Grid item lg={6} xs={12}>
                          <Select
                            id="endProgram"
                            options={endAfter}
                            value={value.endProgram}
                            disabled={value.roundRobin}
                            error={!value.endProgram}
                            setValue={(value) =>
                              handleChangeSelect(value, "endProgram")
                            }
                            label={t("meeting.endProgram")}
                            required={true}
                          />
                        </Grid>
                      ) : (
                        <Grid item lg={6} xs={12}>
                          <KeyboardDatePicker
                            autoOk
                            disableToolbar
                            variant="inline"
                            format={getInputDateFormats(i18n.language)}
                            id="endDate"
                            fullWidth
                            label={t("meeting.endDate")}
                            value={selectedEndDate}
                            disabled={value.roundRobin}
                            error={!selectedEndDate}
                            onChange={(date) => setSelectedEndDate(date)}
                            KeyboardButtonProps={{
                              "aria-label": "change date",
                            }}
                          />
                        </Grid>
                      )}
                    </>
                  )}
                </>
              )}
            </Grid>
          </Paper>
        </Grid>

        <Grid item lg={4} xs={12}>
          <Paper elevation={1} className={classes.paper}>
            <Typography className={classes.title}>
              {t("meeting.participants")}
            </Typography>

            <Grid container spacing={3} className={classes.spacer}>
              <Grid item xs={10} md={12} lg={12}>
                <Select
                  id="participants"
                  options={meetingPartcipantsOptions}
                  value={value?.participant}
                  setValue={(value) => handleChangeSelect(value, "participant")}
                  onInputChange={(_event, newInputValue, _prop) => {
                    setMemberName(newInputValue);
                  }}
                  inputValue={memberName}
                  label={t("name")}
                />
              </Grid>

              {selectedAttendees.map((member, index) => (
                <Grid item xs={12} key={`${member} - ${index}`}>
                  <WrapperChip status={""}>
                    <Chip
                      clickable={false}
                      icon={
                        member.isCommitteeMember ? (
                          <MdGroups style={{ fontSize: "1rem" }} />
                        ) : (
                          <Face />
                        )
                      }
                      label={member.isExternal ? `${member.name} (Externo)` : member.name}
                      onDelete={() => handleRemoveMember(member)}
                      color="primary"
                      style={member.isExternal ? { borderStyle: "dashed" } : {}}
                    />
                  </WrapperChip>
                </Grid>
              ))}
            </Grid>
          </Paper>
        </Grid>
      </Grid>

      <Grid container item direction="row" justify="center" spacing={2}>
        <Grid item>
          <Button
            variant="outlined"
            className={classes.buttonOutlined}
            onClick={() => history.push("/meetings")}
          >
            {t("cancel")}
          </Button>
        </Grid>

        <Grid item>
          <Button
            variant="contained"
            className={classes.button}
            startIcon={<Send style={{ fontSize: 30 }} />}
            onClick={handleSave}
            disabled={!canCreateMeet}
          >
            {t("meeting.saveMeeting")}
          </Button>
        </Grid>
      </Grid>

      <Toastmessage
        message={message.content}
        type={message.type}
        open={message.open}
        autoHideDuration={message.autoHideDuration}
        close={() =>
          setMessage({
            open: false,
            content: "",
            type: "",
            autoHideDuration: 4000,
          })
        }
      />
    </Grid>
  );
};

const withRouterFormSlot = withRouter(FormMetting);

const mapDispatchToProps = (dispatch) => ({
  actionShowSpinner: (request) => dispatch(actionShowSpinner(request)),
});

const FormSlotConnect = connect(null, mapDispatchToProps)(withRouterFormSlot);

export default withTranslation()(FormSlotConnect);
